export class PointSystem {
  id: number;
  name: string;
  startDate: Date;
  endDate: Date;
  department: number;
  superGroup: number;
  group: number;
  assigner: number;
  isDeleted: boolean;
}

export class PointDetail {
  id: number;
  pointSystemId: number;
  task: string;
  points: number;
}

export class GetPointSystemDto {
  pointSystem: PointSystem;
  pointSystemDetails: PointDetail[];
}

export class PointTransaction {
  id: number;
  memberId: number;
  servantId: number;
  pointSystemId: number;
  taskId: number;
  taskPoints: number;
  creationDate: Date;
}

export class MemberPointsDto {
  pointSystems: PointSystem[];
  pointDetails: PointDetail[];
  history: PointTransaction[];
  memberInfo: MemberInfo[];
}

export class MemberPoints {
  memberName: string;
  points: number;
}

export class MemberInfo {
  id: number;
  name: string;
}

export class HistoryInfo {
  Date: Date; 
  Servant: string; 
  Task: string; 
  Points: number;
}